import { PermissionRequirement } from './permission.model';

/** Permisos tenant resource `employees` (paridad Rails). */
export const PAYROLL_EMPLOYEE_PERMISSIONS = {
  list: { resource: 'employees', action: 'index' },
  show: { resource: 'employees', action: 'show' },
  create: { resource: 'employees', action: 'create' },
  update: { resource: 'employees', action: 'update' },
  destroy: { resource: 'employees', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;
